import styled from "styled-components";

export const StyledTitle = styled.h2`
  margin-top: 0;
`;

export const StyledFooter = styled.footer`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 2rem;
`;

